export default __webpack_public_path__ + "744ad70f83d1a2b878e0797b02f35430.png";